export enum DashboardPaths {
  EVENTS = 'events',
  LOCATIONS = 'locations',
  STAFF = 'staff',
  ACCOUNT = 'account',
  SCHEDULER = 'scheduler',
  PROFILE = 'profile',
  CUSTOM_GAME = 'custom-game',
}
